import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVariables: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"variables, figma"} maskId="square-filled-radius-0-stroke-1-IconVariables"><path fillRule="evenodd" clipRule="evenodd" d="M3 6.80357L12 1.60742L21 6.80357V17.1959L12 22.392L3 17.1959V6.80357ZM10 11.9998C10 10.8952 10.8954 9.99976 12 9.99976C13.1046 9.99976 14 10.8952 14 11.9998C14 13.1043 13.1046 13.9998 12 13.9998C10.8954 13.9998 10 13.1043 10 11.9998Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVariables;
